// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1e12cd9f]:export{menuBg:#414146;menuText:#e0e3da;menuActiveText:#fffff3}.layout-tabs[data-v-1e12cd9f]{background:#f7f8fa;padding:6px 0;margin:0 12px 0 12px;display:flex}.layout-tabs-close[data-v-1e12cd9f]{flex-grow:0;flex-shrink:0}.layout-tabs-close-main[data-v-1e12cd9f]{width:32px;height:32px;line-height:32px;text-align:center;background-color:#fff;border-radius:2px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
